<template>
  <div id="footer">
    <footer class="footer bg-black text-white py-4">
      <div class="container" v-bind:class="{ 'd-none': getCookie != -1 }">
        <div class="row">
          <div class="col-12 col-lg-8">
            <p>
              <span class="text-grey"
                >{{ $t("footer.cookies1") }}<br />{{
                  $t("footer.cookies2")
                }}</span
              >
              <u
                ><b
                  ><router-link to="/term-condition" class="text-grey">{{
                    $t("menu.termCond")
                  }}</router-link></b
                ></u
              >
            </p>
          </div>
          <div class="col-12 col-lg-4">
            <button
              class="btn btn-outline-light mt-3 mt-lg-0"
              @click="setCookie()"
            >
              {{ $t("button.accepted") }}
            </button>
          </div>
        </div>
      </div>
      <div class="container-fluid" v-bind:class="{ 'd-none': getCookie != -1 }">
        <div
          class="row border-bottom my-3"
          style="border-color: #464646 !important"
        ></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-6">
            <img
              src="./../../assets/images/footer-mobile.png"
              class="img-fluid"
            />
          </div>
          <div class="col-6 text-right">
            <p class="footer-term">
              <u
                ><b
                  ><router-link to="/term-condition" class="text-white">{{
                    $t("menu.termCond")
                  }}</router-link></b
                ></u
              >
            </p>
          </div>
          <div class="col-6 text-right">
            <p>
              <router-link to="/term-condition" class="text-white"
                >version 1.0.5
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getCookie: "",
    };
  },
  mounted() {
    this.getCookie = document.cookie.indexOf("agenthub");
  },
  methods: {
    setCookie() {
      document.cookie = "agenthub=true";
      this.getCookie = document.cookie.indexOf("agenthub");
    },
  },
};
</script>

<style scoped>
</style>